import compose from 'recompose/compose';
import { connect } from 'react-redux';
import { withLayout } from 'hooks';
import CatalogsMain from './CatalogsMain';

export default withLayout(compose(connect((state) => ({}), {}))(CatalogsMain));
